module.exports = require('./dist/cleave-react-node.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/cleave.js/react.js
 ** module id = 915
 ** module chunks = 0
 **/